module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAASCAYAAACnxdXaAAAAAXNSR0IArs4c6QAAAP9JREFUSEu91U1KBDEQBeD38Bh2z028QTJHUETEA6iIMuqAioj4txFR9BLTuvYmCuk+xuRJ0gqOOLNKUsss6qOKVBWRMDSpbgF80LZ3i9IylammXgH0DpDwfpvD7mZe7mRoAPS6vAXxPsLALo27+g9OikZ4Um2CeIiwtEfbXv6Fk6MRbqoNCI9gqFj7NO3FbzgL2ldcr4N6ArgE+QPa7vwHzob2FQ/WAP8cYWBE487Ce1Y0wm+DVXj/8g0f0bgTqqmVamwW59G0b7XG5VHouGx7hUNad5oVnflIHiMOM3+k4iNTfDkUX4PFF/7MaRN2aN11mdMWjjj1SdOFYz43vgCBhXutfnsWHAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right-active.png
// module id = fQET
// module chunks = 1